var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.user && _vm.user.type=='MANAGER')?_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button"},on:{"click":_vm.showEmpCreateModal}},[_vm._v("\n  "+_vm._s(_vm.labelBtn)+"\n")]):_vm._e(),_vm._v(" "),_c('createEmployeeModal',{key:_vm.uniqueKey,ref:"modal"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }